import { listPatientEligibilities } from '@lotushealth/lotushealth_js_sdk/endpoints';
import { lotusHealthZod } from '@lotushealth/lotushealth_js_sdk';
import type { PatientEligibilitiesResponseT } from '@lotushealth/lotushealth_js_sdk/schemas';

import { createLotusRequestConfig } from '@/shared/api/lotus';

export async function fetchPatientEligibilities(
  patientUserId: string,
  signal?: AbortSignal
): Promise<PatientEligibilitiesResponseT> {
  const config = await createLotusRequestConfig({ signal });
  const response = await listPatientEligibilities(patientUserId, config);
  return lotusHealthZod.listPatientEligibilitiesResponse.parse(
    response.data
  ) as PatientEligibilitiesResponseT;
}
